/* This file was generated automatically. Do not edit manually. */

export enum CommanderOrigin {
    InPerson = 'InPerson',
    Channel = 'Channel',
    Phone = 'Phone',
    Email = 'Email',
    Website = 'Website',
    Message = 'Message',
    CallCenter = 'CallCenter',
}
